<script setup lang="ts">
import useAuthentication from '~/composables/useAuthentication'
import { MARKET_TYPE } from '~/src/constants/markets'
import { useReports } from '~/composables/useReports'
import type { TMarketSlug } from '~/src/types/markets'
import { ALL_MARKETS } from '~/constants/services/constants'

import ReportList from '~/components/critical-insights/ReportList.vue'

const props = defineProps<{ slug: string }>()

const { getReportAndModelData } = useReports()

const market = computed(() => ALL_MARKETS.find((m) => m.slug === props.slug))
const marketName = computed(() => market.value?.name)

const { status, data, refresh } = useAsyncData(
  async () => {
    const reports = await getReportAndModelData(
      props.slug as TMarketSlug,
      [MARKET_TYPE.CRITICAL_INSIGHTS],
      true,
      -1,
    )
    return { reports }
  },
  {
    lazy: true,
    default: () => ({ reports: [] }),
  },
)

useAuthentication(() => refresh())

const reports = computed(() => data.value?.reports)
const isLoading = computed(() => status.value === 'pending')

definePageMeta({ isTab: true })
</script>

<template>
  <TheLoader v-if="isLoading" />
  <ReportList v-else :reports="reports" :market="marketName" />
</template>
